import { useEffect, useState } from "react";
import { POSTS as STATIC_POSTS } from "@/data/blogPosts";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Returns the merged list of published blog posts (static file + AI-scheduled
 * posts fetched from the backend). Static posts render immediately so the
 * page has content even if the network is slow.
 */
export function useAllPosts() {
  const [posts, setPosts] = useState(STATIC_POSTS);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API}/api/blog/posts`);
        if (!r.ok) return;
        const d = await r.json();
        const dynamic = (d.posts || []).map((p) => ({
          slug: p.slug,
          title: p.title,
          category: p.category,
          excerpt: p.excerpt,
          published_at: (p.publish_at || "").slice(0, 10),
          read_min: p.read_min || 6,
          author: p.author || "Creator Intelligence Tube Team",
          // Cover may be relative (/uploads/blog/*.png served by the backend)
          // or an absolute Unsplash URL. Prefix the backend host when needed.
          cover: p.cover && p.cover.startsWith("/") ? `${API}${p.cover}` : p.cover,
          body: p.body || [],
        }));
        if (cancelled) return;
        // De-dupe by slug — dynamic takes precedence when a slug collides.
        const map = new Map();
        for (const p of STATIC_POSTS) map.set(p.slug, p);
        for (const p of dynamic) map.set(p.slug, p);
        setPosts(
          Array.from(map.values()).sort((a, b) =>
            (b.published_at || "").localeCompare(a.published_at || "")
          )
        );
      } catch (err) {
        console.debug("dynamic blog fetch failed", err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return posts;
}
